import loadable from '@loadable/component';

export const Component = loadable(() => import('./components/LivePlayer'));
export { default as propsFormatter } from './propsFormatter';
